<template>
  <div class="product">
    <div class="main-banner" :style="'background-image: url('+bannerList+');'">
			<div class="banner-title">
				<h2>产品服务</h2>
				<h3>Products</h3>
			</div>
		</div>
    <div class="container">
      <div class="main">
        <ul class="proNav">
          <li v-for="item in list" :class="item.id==categoryId?'active':''" :key="item.id" @click="category_btn(item.id)">{{$AppLang == 'en' ? item.name_en : item.name}}</li>
        </ul>
        <div class="right ">
					<div class="productList">
						<div v-for="(proItem,index) in productList" :key="proItem.id" class="proSlide wow fadeInUp" data-wow-duration="1s" :data-wow-delay="index*0.3+'s'" data-wow-offset="20">
							<router-link :to="'/pro-details?goodsId='+proItem.id" >
								<img :src="proItem.title_pic">
								<div class="slideBg el-icon-right">
									<div class="text">
										<div>
											<h4 class="ellipsis">{{$AppLang == 'en' ? proItem.title_en : proItem.title}}</h4>
											<p class="ellipsis">{{$AppLang == 'en' ? proItem.subtitle_en : proItem.subtitle}}</p>
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
        </div>
				<el-pagination
          background layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="pageCount">
         </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
  	name: 'product',
  	data() {
  		return {
        list:[],
				bannerList: [],
        productList: [],
        categoryId: '',
        pageStart: 1,
        pageTotal: 8,
        pageCount: 50
  		};
  	},
    mounted() {
      var categoryId = '';
			if(this.$route.query.categoryId){
				categoryId = this.$route.query.categoryId;
				this.categoryId = categoryId;
			}
			this.category_btn(this.categoryId);
			this.bannerApi();
    },
    methods:{
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
				this.pageStart = val;
				this.goodsPage();
        //console.log(`当前页: ${val}`);
      },
      category_btn(id){
        var that = this;
        var options={ live:false};
        that.categoryId = id
        //根据分类id产品列表请求接口
        that.$api.post(
          '/goods/websiteGoods',
          {
            categoryId: id,
            pageStart: 1,
            pageTotal: 8
          },
          function(res) {
            if(res.data.rtnCode == 200){
              var list = res.data.data;
              that.productList = list.data;
			  if(that.pageStart * that.pageTotal < list.pageCount
			  	&& (that.pageStart + 1) * that.pageTotal > list.pageCount) 
			  	that.pageCount = (that.pageStart + 1) * that.pageTotal;
			  else that.pageCount = list.pageCount;
              that.$nextTick(function(){
              	var wow=new that.$wow.WOW(options).init();
              });
            }else{
              alert(res.data.msg);
            }
			console.log(that.pageCount);
          }
        );
      },
			goodsPage(){
				var that = this;
				//产品列表请求接口
				that.$api.post(
					'/goods/websiteGoods',
					{
						categoryId: that.categoryId,
						pageStart: that.pageStart,
						pageTotal: that.pageTotal
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							that.productList = list.data;
							if(that.pageStart * that.pageTotal < list.pageCount 
								&& (that.pageStart + 1) * that.pageTotal > list.pageCount) 
								that.pageCount = (that.pageStart + 1) * that.pageTotal;
							else if(that.pageStart * that.pageTotal > list.pageCount) that.pageCount = that.pageCount;
							else that.pageCount = list.pageCount;
						}else{
							alert(res.data.msg);
						}
					}
				);
			},
			bannerApi(){
				var that = this;
				//banner请求接口
				that.$api.post(
					'banner/websiteBanners',
					{
						type: 2
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							for(var i=0;i<list.length;i++){
								if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
									list[i].banner = list[i].phone_banner;
								}else{
									list[i].banner = list[i].pic;
								}
							}
							that.bannerList = list[0].banner;
						}else{
							alert(res.data.msg);
						}

					}
				);
			}
    },
    created() {

      var that = this;

      //产品分类请求接口
      that.$api.post(
        '/category/websiteCategorys',
        {},
        function(res) {
          if(res.data.rtnCode == 200){
            var list = res.data.data;
            that.list = list;
          }else{
            alert(res.data.msg);
          }
        }
      );

    },
    metaInfo: {
      title: '佛山鼎吉-产品服务', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
      },
      { // set meta
        name: 'description',
        content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
      }],
      link: [{ // set link
        rel: 'asstes',
        href: 'https://www.dinovor.com/'
      }]
    }
  }
</script>

<style>
.product .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.product .proNav{
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}
.product .proNav li{
	padding: 6px  26px;
	margin-left: 3px;
	color: #717171;
	font-size: 14px;
	transition: all .5s ease;
  cursor: pointer;
}
.product .proNav li::before{
  content: "|";
  position: relative;
  top: 0;
  left: -29px;
  color: #e2e2e2;
}
.product .proNav li:first-child::before{
  display: none;
}
.product .proNav li:hover{
  background-color: #333;
  color: rgba(255,255,255,.62);
}
.product .proNav .active{
  background-color: #333;
  color: rgba(255,255,255,.62);
}


.product .right {
	height: 500px;
	margin-bottom: 50px;
}
.product .productList{
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
}
.product .proSlide{
	display: block;
  overflow: hidden;
  width: 24%;
  position: relative;
  margin: 0 0.5%;
  margin-bottom: 12px;
}
.product .proSlide img{
  transition: all .3s ease;
}
.product .proSlide .slideBg{
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  opacity: 0;
  transition: all .3s ease;
}
.product .proSlide .slideBg .text{
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  box-sizing: border-box;
  padding: 8% 0;
}
.product .proSlide .slideBg .text div{
  transform: translateX(-10%);
  transition: all .3s ease;
}
.product .proSlide .slideBg .text h4{
  font-size: 16px;
  color: #545454;
  line-height: 20px;
  text-align: center;
}
.product .proSlide .slideBg .text p{
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  text-align: center;
}
.product .proSlide .slideBg .text::before{
  content: "";
  position: absolute;
  width: 96%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) scale(1.4);
  border: 1px solid rgba(51,51,51,.36);
  transition: all .3s ease;
}
.product .proSlide .slideBg::before{
  font-size: 20px;
  color: #888;
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-50%);
  transition: all .3s ease;
}
.product .proSlide:hover .slideBg{
  opacity: 1;
}
.product .proSlide:hover img{
  transform: scale(1.1);
}
.product .proSlide:hover .slideBg::before{
  right: 10px;
}
.product .proSlide:hover .slideBg .text div{
  transform: translateX(0);
}
.product .proSlide:hover .slideBg .text::before{
  transform: translate(-50%,-50%) scale(1);
}
.product{
	background: #FFFFFF;
	padding-bottom: 50px;
}
.product .container{
	padding-top: 60px;
}
.product .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #333;
	color: rgba(255,255,255,.62);
}
@media (max-width: 992px){
	.product .right{
		height: auto;
	}
  .product .right .proSlide{
    width: 48%;
		padding: 5px;
		margin: 0 1%;
		margin-bottom: 12px;
		box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
		box-sizing: border-box;
  }
	.product .proNav li{
		padding: 6px 20px;
	}
	.product .proSlide .slideBg{
	  opacity: 1;
	}
	.product .proSlide img{
	  transform: scale(1);
	}
	.product .proSlide .slideBg::before{
	  right: 10px;
	}
	.product .proSlide .slideBg .text div{
	  transform: translateX(0);
	}
	.product .proSlide .slideBg .text::before{
	  transform: translate(-50%,-50%) scale(1);
	}
}

</style>



// WEBPACK FOOTER //
// src/components/product/product.vue